<template>
  <div id="app">
    <HeaderComponent />
    <router-view />
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  name: 'App',
  components: { HeaderComponent, FooterComponent },
  mounted() {
    this._revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('nf-visible');
            this._revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    this._observeAll(true);
    // Full reset on route change
    this.$router.afterEach(() => this.$nextTick(() => this._observeAll(true)));
    // Incremental observe when API data renders new elements
    this._reobserveHandler = () => this.$nextTick(() => this._observeAll(false));
    window.addEventListener('nf-reobserve', this._reobserveHandler);
  },
  beforeUnmount() {
    if (this._revealObserver) this._revealObserver.disconnect();
    window.removeEventListener('nf-reobserve', this._reobserveHandler);
  },
  methods: {
    _observeAll(reset = false) {
      const selector = '.nf-reveal, .nf-reveal-left, .nf-reveal-right, .nf-reveal-scale, .nf-stagger';
      document.querySelectorAll(selector).forEach(el => {
        if (reset) el.classList.remove('nf-visible');
        if (!el.classList.contains('nf-visible')) {
          this._revealObserver.observe(el);
        }
      });
    },
  },
}
</script>

<style>
@import '@/assets/style.css';

#app {
  font-family: 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #4a5568;
}
</style>
